import React, { useState, useEffect } from 'react';
import { leadsAPI } from '../../../services/api';

const ACTION_ICONS = {
  created: '🌱',
  stage_changed: '🔄',
  updated: '✏️',
  followup_scheduled: '📅',
  followup_completed: '✅',
  task_created: '📋',
  meeting_logged: '🎥',
  document_uploaded: '📎',
  audio_uploaded: '🎙',
  note_added: '💬',
  assigned: '👤',
  ai_analyzed: '🤖',
};

export default function ActivityLogTab({ leadId }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  const load = async (p = 1) => {
    try {
      const res = await leadsAPI.getActivityLog(leadId, { page: p, limit: 20 });
      const newLogs = res.data?.data?.logs || [];
      if (p === 1) setLogs(newLogs);
      else setLogs(prev => [...prev, ...newLogs]);
      setHasMore(res.data?.data?.hasMore || false);
      setPage(p);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(1); }, [leadId]);

  const timeAgo = (date) => {
    const diff = (Date.now() - new Date(date)) / 1000;
    if (diff < 60) return 'just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return new Date(date).toLocaleDateString('en-IN');
  };

  return (
    <div>
      <h3 style={{ fontSize: 15, fontWeight: 700, color: '#1B2A6B', marginBottom: 16 }}>Activity Log</h3>

      {loading ? <p style={{ color: '#94a3b8', fontSize: 13 }}>Loading…</p> : logs.length === 0 ? (
        <p style={{ color: '#94a3b8', fontSize: 13, textAlign: 'center', padding: 24 }}>No activity yet</p>
      ) : (
        <div style={{ position: 'relative' }}>
          {/* Timeline line */}
          <div style={{ position: 'absolute', left: 18, top: 0, bottom: 0, width: 2, background: '#e2e8f0' }} />

          {logs.map((log, i) => (
            <div key={log._id || i} style={{ display: 'flex', gap: 14, marginBottom: 16, position: 'relative' }}>
              {/* Icon bubble */}
              <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#fff', border: '2px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0, zIndex: 1 }}>
                {ACTION_ICONS[log.action] || '•'}
              </div>
              <div style={{ flex: 1, paddingTop: 6 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <p
                      title={log.description || log.action?.replace(/_/g, ' ')}
                      style={{ fontSize: 13, color: '#334155', lineHeight: 1.4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'default' }}>
                      <strong style={{ color: '#1B2A6B' }}>{log.user?.name || 'System'}</strong>{' '}
                      {log.description || log.action?.replace(/_/g, ' ')}
                    </p>
                    {log.metadata && Object.keys(log.metadata).length > 0 && (
                      <div
                        title={Object.entries(log.metadata).map(([k, v]) => `${k.replace(/_/g, ' ')}: ${String(v)}`).join(' | ')}
                        style={{ marginTop: 4, padding: '4px 8px', background: '#f8fafc', borderRadius: 6, fontSize: 11, color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'default' }}>
                        {Object.entries(log.metadata).slice(0, 3).map(([k, v]) => (
                          <span key={k} style={{ marginRight: 10 }}>
                            <strong>{k.replace(/_/g, ' ')}:</strong> {String(v)}
                          </span>
                        ))}
                        {Object.keys(log.metadata).length > 3 && (
                          <span style={{ color: '#94a3b8' }}>+{Object.keys(log.metadata).length - 3} more</span>
                        )}
                      </div>
                    )}
                  </div>
                  <span style={{ fontSize: 11, color: '#94a3b8', whiteSpace: 'nowrap', marginLeft: 10 }}>{timeAgo(log.createdAt)}</span>
                </div>
              </div>
            </div>
          ))}

          {hasMore && (
            <div style={{ textAlign: 'center', paddingTop: 8 }}>
              <button onClick={() => load(page + 1)} style={{ fontSize: 13, color: '#1B2A6B', background: 'none', border: '1px solid #e2e8f0', borderRadius: 8, padding: '6px 16px', cursor: 'pointer' }}>
                Load more
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
